import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';

import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import Hls from "hls.js";

import { StreamDetailService } from './StreamDetailService';
import { zip } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-stream-detail',
  templateUrl: './StreamDetail.html',
  styleUrls: ['./StreamDetail.scss']
})
export class StreamDetailComponent extends AbstractComponent {
  
  @ViewChild('stream', {static: false}) 
  public target: ElementRef;

  public registerForm: FormGroup;

  public scope = {
    wait : false,
    streamInfo : null,
    stream : '',
    aiClasses : []
    
  }

  public constructor(
    private title: Title,
    private dialog: MatDialog,
    private service : StreamDetailService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _location: Location,
    private router: Router) {
    super();
    this.title.setTitle("Stream Manager");
    
  }
  /**  */
  public componentWillMount() {    
    this.route.params.subscribe(params => {
      this.scope.stream = params.stream;
      zip(this.service.getStream(this.scope.stream),
          this.service.getVideo(this.scope.stream)).subscribe((res:any) => {
        this.scope.streamInfo = res[0];
        this.registerForm = this.formBuilder.group({
          streamId    : new FormControl(this.scope.streamInfo.streamId, Validators.required),
          streamName  : new FormControl(this.scope.streamInfo.streamName, Validators.required),
          description : new FormControl(this.scope.streamInfo.description),
          dataRetentionInHours: new FormControl(this.scope.streamInfo.dataRetentionInHours, [Validators.required, Validators.pattern(/^[0-9]+$/)]),
          dispOrder: new FormControl(this.scope.streamInfo.dispOrder, [Validators.required, Validators.pattern(/^[0-9]+$/)]),
          aiCheck: new FormControl(this.scope.streamInfo.aiCheck, ),
          aiTargetChecks  : new FormArray([])
        });
        for (let classes of environment.ai_classes) {
          let value = false;
          if (this.scope.streamInfo.aiTargetChecks) {
            if (this.scope.streamInfo.aiTargetChecks.find(e => e == classes)) {
              value = true;
            }
          }
          this.scope.aiClasses.push({
            name : classes,
            value : value,
            select : value,
          })
        }
    
        setTimeout(() => {
          let video = this.target.nativeElement;

          const hls = new Hls();
          hls.loadSource(res[1].url.HLSStreamingSessionURL);
          hls.attachMedia(this.target.nativeElement);
          hls.on(Hls.Events.MEDIA_ATTACHED, () => {
  //          video.style.display = "block";
            video.muted = true;
            video.play();
            hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
              // setTimeout(() => {
              //   console.log(video.videoWidth);
              //   console.log(video.videoHeight);  
              // }, 500);
  
            });
            // let canvas = this.canvas.nativeElement;
            // let ctx = canvas.getContext("2d");
    
            // this.intervalFPS();
            // setTimeout(() => {
            //   resolve(true);
            // }, 100);
    
          });      
        }, 100);
      });
    });
  }


  /** 表示 */
  public render() {

  }

  public chengeCheckbox(index, classes) {
    classes.select = !classes.select;  
    let form = <FormArray> this.registerForm.get('aiTargetChecks'); 
    if (classes.select) {
      form.push(new FormControl(classes.name))
    } else {
      const i = form.controls.findIndex(e => e.value === classes.name);
      if (i) {
        form.removeAt(i);
      }
    }
  }


  public onSubmit() {
    if (this.registerForm.invalid) {
      return;
    }
    let param = this.registerForm.value;
    let aiTargetChecks = [];
    this.scope.aiClasses.map(e => {
      if (e.select) {
        aiTargetChecks.push(e.name);
      };
    })
    param.aiTargetChecks = aiTargetChecks;
    this.service.put(this.registerForm.value.streamId, param).subscribe(((res:any)=> {
      this.toastr.success('Stream update is successful');
      this.router.navigate(['/stream']);
    }));
  }

  public canceClicked() {
    this._location.back();
  }
  
  public get f() {
    return this.registerForm;
  }
}
